import validate from "/app/node_modules/.pnpm/nuxt@3.6.5_@parcel+watcher@2.3.0_@types+node@18.0.0_encoding@0.1.13_rollup@3.28.0_sass@_c3b630c73b6c41d93aba235ae2969034/node_modules/nuxt/dist/pages/runtime/validate.js";
import language_45resolve_45global from "/app/middleware/language.resolve.global.ts";
export const globalMiddleware = [
  validate,
  language_45resolve_45global
]
export const namedMiddleware = {}